import { handleAction, handleActions } from 'redux-actions';
import { CLEAR_PROMO_CODE, clearPromoCode, SET_PROMO_CODE, setPromoCode } from './actions';
export const defaultState = '';
export const setPromoCodeHandler = handleAction(setPromoCode, (state, action) => action.payload, defaultState);
export const clearPromoCodeHandler = handleAction(clearPromoCode, (state, action) => '', defaultState);
export default handleActions({
    [SET_PROMO_CODE]: setPromoCodeHandler,
    [CLEAR_PROMO_CODE]: clearPromoCodeHandler
}, defaultState);
